// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-module__container--3tJgc{color:#303030}.text-module__text--3lyBi{display:inline}.text-module__link--MBBNR{cursor:pointer;color:#36b;display:inline;padding-left:4px}.text-module__link--MBBNR i{font-size:inherit}.text-module__link--MBBNR:hover{text-decoration:underline}\n", ""]);
// Exports
exports.locals = {
	"container": "text-module__container--3tJgc",
	"text": "text-module__text--3lyBi",
	"link": "text-module__link--MBBNR"
};
module.exports = exports;
